/**
 * Shape gallery — pure SVG-markup data used by `createCreativeUnitLayer`
 * when an agent or user adds a `shape` layer without specifying its `shape`
 * content. Index 0 (Rectangle) is the default fallback.
 *
 * Lives here (api utils) so web, mcp-server, and any other layer-creating
 * surface share one source. Pure data — no behavior, no DOM access, safe
 * to import from any context.
 */

export interface ShapeGalleryEntry {
  name: string;
  code: string;
}

export const shapeGallery: ShapeGalleryEntry[] = [
  {
    name: 'Rectangle',
    code: `
			<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" preserveAspectRatio="xMinYMin meet">
				<rect x="0" y="0" width="100%" height="100%" fill="currentColor" />
			</svg>
		`,
  },
  {
    name: 'Circle',
    code: `
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width="100%" height="100%" preserveAspectRatio="xMidYMid meet">
				<circle cx="50" cy="50" r="45" fill="currentColor" />
			</svg>
		`,
  },
  {
    name: 'Triangle',
    code: `
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width="100%" height="100%" preserveAspectRatio="xMidYMid meet">
				<polygon points="50,10 90,90 10,90" fill="currentColor" />
			</svg>
		`,
  },
  {
    name: 'Diamond',
    code: `
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width="100%" height="100%" preserveAspectRatio="xMidYMid meet">
				<polygon points="50,10 90,50 50,90 10,50" fill="currentColor" />
			</svg>
		`,
  },
  {
    name: 'Star',
    code: `
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500" width="100%" height="100%" preserveAspectRatio="xMidYMid meet">
				<polygon points="250,0 305,175 490,175 350,300 405,475 250,370 95,475 150,300 10,175 195,175" fill="currentColor" />
			</svg>
		`,
  },
  {
    name: 'Heart',
    code: `
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500" width="100%" height="100%" preserveAspectRatio="xMidYMid meet">
				<path d="m 250,465 c -350,-233 -233,-584 0,-350 233,-233 350,116 0,350 z" fill="currentColor" />
			</svg>
		`,
  },
  {
    name: 'Pentagon',
    code: `
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width="100%" height="100%" preserveAspectRatio="xMidYMid meet">
				<polygon points="50,8 92,39.9 79.1,92 20.9,92 8,39.9" fill="currentColor" />
			</svg>
		`,
  },
  {
    name: 'Hexagon',
    code: `
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width="100%" height="100%" preserveAspectRatio="xMidYMid meet">
				<polygon points="50,5 95,27.5 95,72.5 50,95 5,72.5 5,27.5" fill="currentColor" />
			</svg>
		`,
  },
  {
    name: 'Octagon',
    code: `
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width="100%" height="100%" preserveAspectRatio="xMidYMid meet">
				<polygon points="28.5,5 71.5,5 95,28.5 95,71.5 71.5,95 28.5,95 5,71.5 5,28.5" fill="currentColor" />
			</svg>
		`,
  },
  {
    name: 'Arrow',
    code: `
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width="100%" height="100%" preserveAspectRatio="xMidYMid meet">
				<polygon points="10,50 50,10 50,35 90,35 90,65 50,65 50,90" fill="currentColor" />
			</svg>
		`,
  },
  {
    name: 'X',
    code: `
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120" width="100%" height="100%" preserveAspectRatio="xMidYMid meet">
			  <polygon points="20,10 10,20 50,60 10,100 20,110 60,70 100,110 110,100 70,60 110,20 100,10 60,50" fill="currentColor"/>
			</svg>
		`,
  },
  {
    name: 'Checkmark',
    code: `
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width="100%" height="100%" preserveAspectRatio="xMidYMid meet">
				<path d="M10,50 L40,80 L90,20 L80,10 L40,60 L20,40 Z" fill="currentColor"/>
			</svg>
		`,
  },
];
